import React from 'react'
import MediaQuery from 'react-responsive'

const Breakpoint = breakpoint => ({
  Small: props => <MediaQuery maxWidth={breakpoint} {...props} />,
  Large: props => <MediaQuery minWidth={breakpoint + 1} {...props} />
})

export default Breakpoint
